import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SimpleBlueSection = ({ title, value }) => {
  if (!value) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
        borderRadius:'0px'
      }}
    >
      {/* Blue Header */}
      <Box
        sx={{
          backgroundColor: '#5569ff',
          color: '#fff',
          px: '8px',
          py: '4px',
         
        }}
      >
        {title}
      </Box>

      {/* Content */}
      <Box sx={{ px: '8px', py: '4px' }}>
        <Typography>{value}</Typography>
      </Box>
    </Paper>
  );
};

const ClausesCoverageChanges = ({ data }) => {
 
  if (!data) return null;

  return (
    <>
      <SimpleBlueSection
        title="Coverages"
        value={data?.coverageRemark?.newValue}
      />

      <SimpleBlueSection
        title="Clauses"
        value={data?.clausesRemark?.newValue}
      />
    </>
  );
};

export default ClausesCoverageChanges;